//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import classNames from 'classnames';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { BootstrapIcon } from '../BootstrapIcon'; 
import './Banners.css';

export function BetaBanner() {

    const [ isOpen, setOpen ] = useState(false);

    const divClass = classNames('beta-banner', 'd-flex', 'justify-content-between', { 'hide-banner': !isOpen } )
    return(<>
        <div className={divClass}>
            <div></div>
            <div>
                Having issues with the new Choice website? Return to the <a href="https://old-member.choicesocialclub.com">classic website</a>
            </div>
            <div onClick={() => setOpen(false)}>
                <BootstrapIcon icon="x" />
            </div>
        </div>
        <Outlet />
    </>) 
}

